import { createPromiseClient } from '@bufbuild/connect-web';
import { AccountManager } from '@/generated/msh/service/v1/account_manager_connectweb';
import { GetCurrentAccountsRequest } from '@/generated/msh/service/v1/account_manager_pb';
import { transport } from '../transport';

const client = createPromiseClient(AccountManager, transport);

export async function fetchAccounts(signal) {
  const response = await client.getCurrentAccounts(
    new GetCurrentAccountsRequest(),
    { signal }
  );

  return response.accounts;
}
